import { Button, DialogTitle, FormControl, Radio, RadioGroup } from "@mui/material";
import { DialogActions } from "@mui/material";
import { Stack } from "@mui/material";
import { DialogContent, FormControlLabel, Typography } from "@mui/material";
import { TFazendaPublico } from "../../types/api/geral/pesquisar-publicos";
import { Dialog } from "@mui/material";
import { useState } from "react";
import moment from 'moment';
import { enqueueSnackbar } from "notistack";

export function DialogSelecionarFazenda({
    open,
    handleClose,
    fazendas,
    onSelect,
}: DialogSelecionarFazendaProps) {
    
    const [selectedFazenda, setSelectedFazenda] = useState<TFazendaPublico | null>(
        fazendas.length > 0 ? fazendas[0] : null
    );

    const handleSubmit = () => {
        if (!selectedFazenda) return onSelect(null);
        
        if (selectedFazenda.inscricao_vencimento !== '0000-00-00') {
            const dataVencimento = moment(selectedFazenda.inscricao_vencimento);
            const dataAtual = moment();

            if (dataVencimento.isBefore(dataAtual)) {
                enqueueSnackbar('Não é possível selecionar esta fazenda pois a inscrição está vencida.', {
                    variant: 'warning',
                });
                return;
            }
        }

        onSelect(selectedFazenda);
    };

    return (
        <Dialog open={open} maxWidth="xs" fullWidth>
            <DialogTitle>Selecionar Fazenda</DialogTitle>

            <DialogContent>
                <FormControl component="fieldset" fullWidth>
                    <RadioGroup
                        value={!selectedFazenda ? "sem_fazenda" : selectedFazenda.inscricao}
                        onChange={(_, value) => {
                            setSelectedFazenda(value === "sem_fazenda" ? null : fazendas.find(f => f.inscricao === value) || null)
                        }}
                    >
                        {fazendas.map((fazenda) => (
                            <FormControlLabel
                                key={fazenda.inscricao}
                                value={fazenda.inscricao}
                                control={<Radio />}
                                label={
                                    <Stack mt={1.5}>
                                        <Typography>
                                            {fazenda.apelido} - {fazenda.nome}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Siare: {fazenda.siare}
                                        </Typography>
                                    </Stack>
                                }
                            />
                        ))}
                        <FormControlLabel
                            value="sem_fazenda"
                            control={<Radio />}
                            label={
                                <Typography >
                                    Não informar fazenda
                                </Typography>
                            }
                        />
                    </RadioGroup>
                </FormControl>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                >
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    );
}


interface DialogSelecionarFazendaProps {
    open: boolean;
    handleClose: () => void;
    fazendas: TFazendaPublico[];
    onSelect: (fazenda: TFazendaPublico | null) => void;
}